/**
 * Product Zoom - Vegan Essentials
 * SWA-255: Image zoom functionality for PDP
 *
 * Features:
 * - Desktop: Hover zoom with lens and magnified panel
 * - Mobile: Full-screen lightbox with pinch-to-zoom
 * - Video: HTML5, YouTube, and Vimeo support in lightbox
 */

(function() {
  'use strict';

  // Configuration from theme settings (passed via Liquid)
  const config = window.productZoomConfig || {
    enableDesktopHover: true,
    enableMobileLightbox: true,
    zoomLevel: 2.5
  };

  // Constants
  const LENS_SIZE = 120;
  const BREAKPOINT_MOBILE = 768;

  // Device detection
  const isTouchDevice = function() {
    return ('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0);
  };

  const isMobile = function() {
    return window.innerWidth < BREAKPOINT_MOBILE;
  };

  // PhotoSwipe instance
  let pswpLightbox = null;

  /**
   * Initialize PhotoSwipe lightbox for full-screen gallery
   */
  function initPhotoSwipe() {
    // Check if PhotoSwipe is loaded
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
      console.warn('PhotoSwipe not loaded');
      return;
    }

    const gallery = document.querySelector('.product-media');
    if (!gallery) return;

    // Get all gallery items
    const items = buildGalleryItems();
    if (items.length === 0) return;

    pswpLightbox = new PhotoSwipeLightbox({
      pswpModule: PhotoSwipe,

      // Use data source mode (not gallery mode) for cross-browser compatibility
      dataSource: items,

      // Zoom options
      initialZoomLevel: 'fit',
      secondaryZoomLevel: config.zoomLevel,
      maxZoomLevel: 4,

      // UI options
      bgOpacity: 0.92,
      showHideAnimationType: 'zoom',

      // Accessibility
      arrowPrevTitle: 'Previous image',
      arrowNextTitle: 'Next image',
      closeTitle: 'Close gallery (Escape)',
      zoomTitle: 'Zoom image',

      // Padding
      paddingFn: function(viewportSize) {
        return {
          top: 30,
          bottom: viewportSize.y < 600 ? 60 : 30,
          left: 0,
          right: 0
        };
      }
    });

    // Override click to get correct index from Slick
    pswpLightbox.on('itemData', function(e) {
      const { itemData, index } = e;

      // If it's a video item, set up HTML content
      if (itemData.type === 'html') {
        // Content will be set in contentLoad event
      }
    });

    // Handle video content loading
    pswpLightbox.on('contentLoad', function(e) {
      const { content } = e;

      if (content.data.type === 'html' && content.data.videoId) {
        e.preventDefault();

        content.element = document.createElement('div');
        content.element.className = 'pswp-video-container';
        content.element.style.cssText = 'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;';

        if (content.data.videoHost === 'youtube') {
          content.element.innerHTML = getYouTubeEmbed(content.data.videoId);
        } else if (content.data.videoHost === 'vimeo') {
          content.element.innerHTML = getVimeoEmbed(content.data.videoId);
        } else {
          // HTML5 video from template
          const template = document.getElementById(content.data.videoTemplate);
          if (template) {
            content.element.appendChild(template.content.cloneNode(true));
            // Style the video element - use explicit dimensions to ensure visibility
            const video = content.element.querySelector('video');
            if (video) {
              video.style.cssText = 'width: 100%; height: 100%; max-width: 100%; max-height: 100%; object-fit: contain;';
            }
          } else {
            content.element.innerHTML = '<p style="color: white; text-align: center;">Video not available</p>';
          }
        }

        content.state = 'loaded';
      }
    });

    // Append video content to PhotoSwipe container
    pswpLightbox.on('contentAppend', function(e) {
      const { content } = e;
      if (content.data.type === 'html' && content.element) {
        e.preventDefault();
        content.slide.container.appendChild(content.element);
      }
    });

    // Remove video content when slide changes
    pswpLightbox.on('contentRemove', function(e) {
      const { content } = e;
      if (content.data.type === 'html' && content.element) {
        e.preventDefault();
        // Pause video before removing
        const video = content.element.querySelector('video');
        if (video) {
          video.pause();
        }
        content.element.remove();
      }
    });

    // Pause all videos when lightbox closes
    pswpLightbox.on('close', function() {
      pauseAllVideos();
    });

    pswpLightbox.init();

    // Manually bind click events for cross-browser compatibility
    // (PhotoSwipe's auto-binding with gallery/children doesn't work reliably in Firefox/WebKit)
    gallery.querySelectorAll('.product-zoom-trigger, .product-video-trigger').forEach(function(trigger, index) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();

        // Get the index from the parent slide's data attribute, or fallback to DOM position
        var slide = trigger.closest('.product-media-slide');
        var slideIndex = slide ? parseInt(slide.dataset.pswpIndex) : index;

        // If using Slick, get current slide index
        if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
          var slickSlider = jQuery('#product_slider');
          if (slickSlider.length && slickSlider.hasClass('slick-initialized')) {
            slideIndex = slickSlider.slick('slickCurrentSlide');
          }
        }

        pswpLightbox.loadAndOpen(slideIndex);
      });
    });
  }

  /**
   * Build gallery items array for PhotoSwipe from DOM
   */
  function buildGalleryItems() {
    const items = [];
    const slides = document.querySelectorAll('.product-media-slide');

    slides.forEach(function(slide, index) {
      const type = slide.dataset.pswpType;

      if (type === 'image') {
        items.push({
          src: slide.dataset.pswpSrc,
          width: parseInt(slide.dataset.pswpWidth) || 1600,
          height: parseInt(slide.dataset.pswpHeight) || 1600,
          alt: slide.dataset.pswpAlt || '',
          type: 'image'
        });
      } else if (type === 'html') {
        // Video item - PhotoSwipe requires width/height for HTML content
        items.push({
          html: '<div class="pswp-video-placeholder"></div>',
          width: 1280,
          height: 720,
          type: 'html',
          videoId: slide.dataset.videoId,
          videoHost: slide.dataset.videoHost || 'html5',
          videoTemplate: 'video-template-' + slide.dataset.videoId
        });
      }
    });

    return items;
  }

  /**
   * Get YouTube embed HTML
   */
  function getYouTubeEmbed(videoId) {
    return '<div class="pswp-youtube">' +
      '<iframe ' +
        'src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&enablejsapi=1" ' +
        'width="854" ' +
        'height="480" ' +
        'frameborder="0" ' +
        'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
        'allowfullscreen>' +
      '</iframe>' +
    '</div>';
  }

  /**
   * Get Vimeo embed HTML
   */
  function getVimeoEmbed(videoId) {
    return '<div class="pswp-vimeo">' +
      '<iframe ' +
        'src="https://player.vimeo.com/video/' + videoId + '?autoplay=1" ' +
        'width="854" ' +
        'height="480" ' +
        'frameborder="0" ' +
        'allow="autoplay; fullscreen; picture-in-picture" ' +
        'allowfullscreen>' +
      '</iframe>' +
    '</div>';
  }

  /**
   * Pause all videos (called on lightbox close)
   */
  function pauseAllVideos() {
    // HTML5 videos
    document.querySelectorAll('.pswp-video-container video').forEach(function(v) {
      v.pause();
    });

    // YouTube iframes - send pause command
    document.querySelectorAll('.pswp-youtube iframe').forEach(function(iframe) {
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      } catch (e) {
        // Ignore cross-origin errors
      }
    });

    // Vimeo iframes - send pause command
    document.querySelectorAll('.pswp-vimeo iframe').forEach(function(iframe) {
      try {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (e) {
        // Ignore cross-origin errors
      }
    });
  }

  /**
   * Initialize desktop hover zoom functionality
   */
  function initDesktopHoverZoom() {
    // Skip on touch devices or if disabled
    if (isTouchDevice() || !config.enableDesktopHover) {
      return;
    }

    const productMedia = document.querySelector('.product-media');
    if (!productMedia) return;

    // Create zoom result panel (once, outside of slides)
    const zoomResult = document.createElement('div');
    zoomResult.className = 'zoom-result';
    zoomResult.setAttribute('aria-hidden', 'true');
    zoomResult.setAttribute('role', 'img');
    productMedia.appendChild(zoomResult);

    // Set up each image for hover zoom
    const triggers = document.querySelectorAll('.product-zoom-trigger');

    triggers.forEach(function(trigger) {
      const img = trigger.querySelector('.product-main-image');
      if (!img) return;

      // Create lens for this trigger
      const lens = document.createElement('div');
      lens.className = 'zoom-lens';
      lens.setAttribute('aria-hidden', 'true');
      trigger.appendChild(lens);

      // Preload zoom image data
      let zoomImageLoaded = false;
      let zoomImageSrc = img.dataset.zoomSrc;
      let zoomImage = null;

      // Mouse enter - activate zoom
      trigger.addEventListener('mouseenter', function(e) {
        if (!zoomImageSrc) return;

        // Preload zoom image if not already loaded
        if (!zoomImageLoaded) {
          trigger.classList.add('loading');
          zoomImage = new Image();
          zoomImage.onload = function() {
            zoomImageLoaded = true;
            trigger.classList.remove('loading');

            // Set background on result panel
            zoomResult.style.backgroundImage = 'url(' + zoomImageSrc + ')';
            zoomResult.style.backgroundSize = zoomImage.width + 'px ' + zoomImage.height + 'px';

            lens.classList.add('active');
            zoomResult.classList.add('active');
          };
          zoomImage.onerror = function() {
            trigger.classList.remove('loading');
          };
          zoomImage.src = zoomImageSrc;
        } else {
          lens.classList.add('active');
          zoomResult.classList.add('active');
        }
      });

      // Mouse move - move lens and update background position
      trigger.addEventListener('mousemove', function(e) {
        if (!lens.classList.contains('active')) return;

        const rect = img.getBoundingClientRect();

        // Get cursor position relative to image
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;

        // Constrain lens position to stay within image
        const halfLens = LENS_SIZE / 2;
        x = Math.max(halfLens, Math.min(x, rect.width - halfLens));
        y = Math.max(halfLens, Math.min(y, rect.height - halfLens));

        // Position lens centered on cursor
        lens.style.left = x + 'px';
        lens.style.top = y + 'px';
        lens.style.transform = 'translate(-50%, -50%)';

        // Calculate background position for zoom result
        // Map cursor position to percentage of image
        const bgX = (x / rect.width) * 100;
        const bgY = (y / rect.height) * 100;

        zoomResult.style.backgroundPosition = bgX + '% ' + bgY + '%';
      });

      // Mouse leave - deactivate zoom
      trigger.addEventListener('mouseleave', function() {
        lens.classList.remove('active');
        zoomResult.classList.remove('active');
      });

      // Prevent default on click for desktop to avoid opening lightbox while zooming
      // Only open lightbox on click if zoom is not active or user double-clicks
      let clickTimer = null;
      trigger.addEventListener('click', function(e) {
        // If zoom result is active, this is a zoom interaction, don't open lightbox
        // unless it's a double-click
        if (zoomResult.classList.contains('active')) {
          if (clickTimer) {
            // Double-click - open lightbox
            clearTimeout(clickTimer);
            clickTimer = null;
            // Let PhotoSwipe handle it
          } else {
            // Single click - wait to see if double-click
            e.preventDefault();
            e.stopPropagation();
            clickTimer = setTimeout(function() {
              clickTimer = null;
            }, 300);
          }
        }
      });
    });
  }

  /**
   * Sync zoom with Slick carousel
   */
  function initSlickSync() {
    // Wait for jQuery and Slick to be ready
    if (typeof jQuery === 'undefined') return;

    var $ = jQuery;

    // Listen for variant changes to update gallery
    var variantSelect = document.querySelector('.selected_variant');
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        var imageId = selectedOption.dataset.imageId;

        if (imageId) {
          // Find the slide with this media ID
          var slides = document.querySelectorAll('.product-media-slide');
          slides.forEach(function(slide, index) {
            var trigger = slide.querySelector('[data-media-id="' + imageId + '"]');
            if (trigger) {
              // Use Slick's slickGoTo to navigate
              $('#product_slider').slick('slickGoTo', index);
            }
          });
        }
      });
    }

    // Listen for Slick afterChange to preload zoom images
    $('#product_slider').on('afterChange', function(event, slick, currentSlide) {
      var activeSlide = slick.$slides.get(currentSlide);
      if (activeSlide) {
        preloadZoomImage(activeSlide);
      }
    });

    // Preload first image zoom on init
    var firstSlide = document.querySelector('.product-media-slide');
    if (firstSlide) {
      preloadZoomImage(firstSlide);
    }
  }

  /**
   * Preload zoom image for a slide
   */
  function preloadZoomImage(slide) {
    var img = slide.querySelector('.product-main-image');
    if (!img || !img.dataset.zoomSrc) return;

    var preload = new Image();
    preload.src = img.dataset.zoomSrc;
  }

  /**
   * Handle keyboard navigation for accessibility
   */
  function initKeyboardNav() {
    document.addEventListener('keydown', function(e) {
      // Only when focus is on a zoom trigger
      var trigger = document.activeElement;
      if (!trigger || !trigger.classList.contains('product-zoom-trigger')) return;

      if (e.key === 'Enter' || e.key === ' ') {
        // Open lightbox
        e.preventDefault();
        trigger.click();
      }
    });
  }

  /**
   * Handle window resize
   */
  function initResizeHandler() {
    var resizeTimer;

    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Re-evaluate touch device status on resize
        // This helps with device rotation
        var zoomResult = document.querySelector('.zoom-result');
        if (zoomResult) {
          if (isTouchDevice() || isMobile()) {
            zoomResult.classList.remove('active');
          }
        }
      }, 250);
    });
  }

  /**
   * Main initialization
   */
  function init() {
    // Only run on pages with product media
    var productMedia = document.querySelector('.product-media');
    if (!productMedia) return;

    // Initialize PhotoSwipe lightbox
    initPhotoSwipe();

    // Initialize desktop hover zoom
    initDesktopHoverZoom();

    // Initialize Slick carousel sync
    initSlickSync();

    // Initialize keyboard navigation
    initKeyboardNav();

    // Initialize resize handler
    initResizeHandler();

    // Mark as initialized
    productMedia.dataset.zoomInitialized = 'true';
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
